<div class="mat-card">
    <div class="p-16">
        <div class="h1 pr-16">Servicios Complementarios</div>
    </div>

    <table class="simple">
        <thead>
            <tr>
                <th>Servicio</th>

                <th class="text-right"></th>
            </tr>
        </thead>
        <tbody>
            <tr
                *ngFor="
                    let servicio of serviciosComplementarios.servicios;
                    let idx = index
                "
            >
                <td class="cursor-pointer" (click)="editar(servicio, idx)">
                    <small
                        ><strong>{{ idx + 1 }} - {{ servicio.nombre }} </strong>
                        ({{ servicio.nombreSucursal }})
                        <mat-icon color="accent">edit</mat-icon>
                    </small>
                </td>

                <td class="text-right">
                    <button mat-icon-button color="warn" (click)="quitar(idx)">
                        <mat-icon>delete_forever</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>

    <div class="card-divider full-width"></div>

    <div class="p-8 pt-16" fxLayout="row" fxLayoutAlign="start center">
        <button mat-button color="accent" (click)="agregar()">AGREGAR</button>
    </div>
</div>
